// extracted by mini-css-extract-plugin
module.exports = {"home_page":"Home_home_page__2xfY-","home_page_box":"Home_home_page_box__1hK3i"};